import {HrTool} from '@frontend/directus';
import {ToolPhaseScores} from '../../../../../../../shared/services/overall-score.service';
import {CurrencyData} from '@frontend/shared';

export const OVERALL_RESULT_VIEW = {
  EXECUTIVE_SUMMARY: 'executive_summary',
  DETAILED_ANALYSIS: 'detailed_analysis',
  COST_COMPARISON: 'cost_comparison',
  MODULE_COMPARISON: 'module_comparison',
} as const;

export type OverallResultView = (typeof OVERALL_RESULT_VIEW)[keyof typeof OVERALL_RESULT_VIEW];

export interface ProviderOverallResult {
  hrTool: HrTool;
  translatedName: string;
  scores: ToolPhaseScores;
  rank: number;
  rfqTotalCostThreeYears?: number;
  rfqCurrencyData?: CurrencyData;
}

export interface SummaryTile {
  labelKey: string;
  icon: string;
  toolName: string;
  value: string;
  variant: 'winner' | 'functional-fit' | 'demo' | 'value';
  currencyData?: CurrencyData;
}
